import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import CalculatorPopup from "./Calculatorpopup.js";

const IndexSection = ({volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually, ufoPrice}) => {

  const [calculatorModalOpen, setCalculatorModalOpen] = useState(false);
  const openCalculator = () => setCalculatorModalOpen(true);
  const closeCalculatorModal = () => setCalculatorModalOpen(false);
  
  return (
    <>
      <div className="statsSN   subcontent  " data-aos="fade-up"  data-aos-delay="300" data-aos-duration="400">
        <div className="imgBg text-center"><img src="./images/UFO_big_circle.svg" className="img-fluid" /></div>
        <h2 className="gradient-stroke-text">Calculator</h2>
        <p>Use the UFO calculators to craft your own future simulation. These tools assist users in making informed predictions about the potential growth of PulseChain and UFO.</p>
        <div className="mt-0 pt-1 mySPace"></div>
        <button className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center" onClick={openCalculator} >
          <span>Calculate Now</span> <img className="img-fluid" src="./images/circle_arrow.svg" />
        </button>
      </div>
      <CalculatorPopup 
        modalIsOpen={calculatorModalOpen} 
        closeModal={closeCalculatorModal}  
        volumeDaily={volumeDaily} 
        volumeWeekly={volumeWeekly} 
        volumeMonthly={volumeMonthly} 
        volumeSemiAnnually={volumeSemiAnnually} 
        volumeAnnually={volumeAnnually} 
        ufoPrice={ufoPrice}
      />
    </>
  );
};

export default IndexSection;
